// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-collapse {
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_13-collapse[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_13-collapse > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_13-collapse .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_13-collapse-wrapper {
  /* Collapse Typography */
  --perxis-auto-collapse-font-family-inner: var(
    --perxis-auto-collapse-font-family,
    var(--perxis-auto-root-typography-h5-font-family-inner)
  );
  --perxis-auto-collapse-font-size-inner: var(
    --perxis-auto-collapse-font-size,
    var(--perxis-auto-root-typography-h5-font-size-xxl-inner)
  );
  --perxis-auto-collapse-font-size-xxs-xs-inner: var(
    --perxis-auto-collapse-font-size-xxs-xs,
    var(--perxis-auto-collapse-font-size-inner)
  );
  --perxis-auto-collapse-font-size-sm-xxl-inner: var(
    --perxis-auto-collapse-font-size-sm-xxl,
    var(--perxis-auto-collapse-font-size-inner)
  );
  --perxis-auto-collapse-font-weight-inner: var(
    --perxis-auto-collapse-font-weight,
    var(--perxis-auto-root-typography-h5-font-weight-inner)
  );
  --perxis-auto-collapse-letter-spacing-inner: var(
    --perxis-auto-collapse-letter-spacing,
    var(--perxis-auto-root-typography-h5-letter-spacing-inner)
  );
  --perxis-auto-collapse-line-height-inner: var(
    --perxis-auto-collapse-line-height,
    var(--perxis-auto-root-typography-h5-line-height-xxl-inner)
  );
  --perxis-auto-collapse-text-transform-inner: var(
    --perxis-auto-collapse-text-transform,
    var(--perxis-auto-root-typography-h5-text-transform-inner)
  );
  --perxis-auto-collapse-font-variant-numeric-inner: var(
    --perxis-auto-collapse-font-variant-numeric,
    var(--perxis-auto-root-typography-h5-font-variant-numeric-inner)
  );
  --perxis-auto-collapse-header-color-inner: var(
    --perxis-auto-collapse-header-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Collapse Typography */
  /* Icon Colors */
  --perxis-auto-collapse-arrow-color-inner: var(
    --perxis-auto-collapse-arrow-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  --perxis-auto-collapse-active-arrow-color-inner: var(
    --perxis-auto-collapse-active-arrow-color,
    var(--perxis-auto-collapse-arrow-color-inner)
  );
  /* End Icon Colors */
  /* Collapse Colors */
  --perxis-auto-collapse-background-color-inner: var(
    --perxis-auto-collapse-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Collapse Colors */
  /* Collapse Padding */
  --perxis-auto-collapse-padding-inner: var(
    --perxis-auto-collapse-padding,
    var(--perxis-auto-gap-vertical-sky-inner) 18px var(--perxis-auto-gap-vertical-sky-inner) 18px
  );
  /* End Collapse Padding */
  /* Collapse Panel Typography */
  --perxis-auto-collapse-panel-font-family-inner: var(
    --perxis-auto-collapse-panel-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-collapse-panel-font-size-inner: var(
    --perxis-auto-collapse-panel-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-collapse-panel-font-weight-inner: var(
    --perxis-auto-collapse-panel-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-collapse-panel-letter-spacing-inner: var(
    --perxis-auto-collapse-panel-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-collapse-panel-line-height-inner: var(
    --perxis-auto-collapse-panel-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-collapse-panel-text-transform-inner: var(
    --perxis-auto-collapse-panel-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-collapse-panel-font-variant-numeric-inner: var(
    --perxis-auto-collapse-panel-font-variant-numeric,
    var(--perxis-auto-root-typography-main-font-variant-numeric-inner)
  );
  --perxis-auto-collapse-panel-color-inner: var(
    --perxis-auto-collapse-panel-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Collapse Panel  Typography */
  /* Collapse Panel  Padding */
  --perxis-auto-collapse-panel-padding-inner: var(
    --perxis-auto-collapse-panel-padding,
    var(--perxis-auto-gap-vertical-sky-inner) 18px var(--perxis-auto-gap-vertical-sky-inner) 18px
  );
  /* End Collapse Panel Padding */
  /* Collapse Panel Divider */
  --perxis-auto-collapse-divider-color-inner: var(
    --perxis-auto-collapse-divider-color,
    var(--perxis-auto-root-ninth-color-inner)
  );
  --perxis-auto-collapse-divider-width-inner: var(--perxis-auto-collapse-divider-width, 1px);
  --perxis-auto-collapse-divider-border-radius-inner: var(--perxis-auto-collapse-divider-border-radius, 0);
  /* End Collapse Panel Divider */
}
.perxis-auto-1_16_13-collapse-wrapper {
  display: flex;
  flex-direction: column;
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse {
  display: flex;
  flex-direction: column;
  border: none;
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse,
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-header {
  font-family: var(--perxis-auto-collapse-font-family-inner);
  font-size: var(--perxis-auto-collapse-font-size-xxs-xs-inner);
  line-height: var(--perxis-auto-collapse-line-height-inner);
  font-weight: var(--perxis-auto-collapse-font-weight-inner);
  text-transform: var(--perxis-auto-collapse-text-transform-inner);
  letter-spacing: var(--perxis-auto-collapse-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-collapse-font-variant-numeric-inner);
  color: var(--perxis-auto-collapse-header-color-inner);
  background-color: var(--perxis-auto-collapse-background-color-inner);
}
@media (min-width: 576px) {
  .perxis-auto-1_16_13-collapse.ant-5_17_0-collapse,
  .perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-header {
    font-size: var(--perxis-auto-collapse-font-size-sm-xxl-inner);
  }
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-item .ant-5_17_0-collapse-header {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  user-select: none;
  transition: all 0.3s, visibility 0s;
  padding: var(--perxis-auto-collapse-padding-inner);
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-item .ant-5_17_0-collapse-header .ant-5_17_0-collapse-header-text {
  flex: auto;
  margin-inline-end: auto;
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-item .ant-5_17_0-collapse-header .ant-5_17_0-collapse-arrow {
  color: var(--perxis-auto-collapse-arrow-color-inner);
  fill: var(--perxis-auto-collapse-arrow-color-inner);
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-item-active > .ant-5_17_0-collapse-header .ant-5_17_0-collapse-arrow {
  color: var(--perxis-auto-collapse-active-arrow-color-inner);
  fill: var(--perxis-auto-collapse-active-arrow-color-inner);
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-item {
  border-bottom: var(--perxis-auto-collapse-divider-width-inner) solid var(--perxis-auto-collapse-divider-color-inner);
  border-radius: var(--perxis-auto-collapse-divider-border-radius-inner);
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-item .ant-5_17_0-collapse-content {
  border: none;
  background-color: inherit;
  color: var(--perxis-auto-collapse-panel-color-inner);
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-item .ant-5_17_0-collapse-content > .ant-5_17_0-collapse-content-box {
  font-family: var(--perxis-auto-collapse-panel-font-family-inner);
  font-size: var(--perxis-auto-collapse-panel-font-size-inner);
  line-height: var(--perxis-auto-collapse-panel-line-height-inner);
  font-weight: var(--perxis-auto-collapse-panel-font-weight-inner);
  text-transform: var(--perxis-auto-collapse-panel-text-transform-inner);
  letter-spacing: var(--perxis-auto-collapse-panel-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-collapse-panel-font-variant-numeric-inner);
  padding: var(--perxis-auto-collapse-panel-padding-inner);
}
.perxis-auto-1_16_13-collapse.ant-5_17_0-collapse .ant-5_17_0-collapse-item .ant-5_17_0-collapse-content > .ant-5_17_0-collapse-content-box:first-of-type {
  padding-top: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
